"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aideLastVisitFormToPayloadDataHandler = aideLastVisitFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function aideLastVisitFormToPayloadDataHandler(data) {
    const now = (0, dayjs_1.default)();
    return {
        form: {
            visitDate: data.visitDate,
            notes: data.notes,
            offSet: now.utcOffset(),
        },
    };
}
